export class StatusProtocolo {
  idStatus: number;
  descricao : string;
  statusSAP?: string;
  motivo: string;
  tipo: string;
  }